import { BASE_URL } from "../constants";
import { DropOffEntity } from "../entities/DropOffEntity";
import { ReportDropOffEntity } from "../entities/ReportEnity";
import FetchUtils from "../utils/fetch";

class VendorDropoffService {
    static async GetAllVendorDropoff(): Promise<DropOffEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/dropoff`);
        if (resp.status != 200) { throw resp.message }

        const data: DropOffEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(({
                id: resp.data[i].ID,
                tanggal: resp.data[i].Tanggal,
                shift: resp.data[i].Shift,
                vendor: resp.data[i].Vendor,
                lokasi_drop_off: resp.data[i].LokasiDropoff,
                id_requestor: resp.data[i].IDKaryawan,
                requestor: resp.data[i].Karyawan,
                penerima: resp.data[i].Penerima,
                porsi_reguler: resp.data[i].QtyRegular,
                porsi_vegetarian: resp.data[i].QtyVegetarian,
                status: resp.data[i].Status,
            }))
        }

        return data;
    }

    static async GetFileVendorDropoff(data: DropOffEntity | ReportDropOffEntity): Promise<any> {
        let resp = await FetchUtils.fetchFile(`${BASE_URL}/api/v1/vendors/dropoff/file?id_vendor_dropoff=${data.id}`);
        if (resp.status != 200) { throw (await resp.json()).message }

        return resp;
    }

    static async AddVendorDropoff(data: {
        id_vendor_porsi: number,
        id_karyawan: number,
        shift: 1 | 2 | 3 | 0,
        lokasi_dropoff: string,
        qty_regular: number,
        qty_vegetarian: number,
    }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/dropoff/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async AcceptOrRejectDropoff(data: DropOffEntity, status: "ACC" | "REJECT"): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/dropoff/status`,
            {
                method: 'POST',
                body: JSON.stringify({
                    id_vendor_dropoff: data.id,
                    status: status,
                })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async UploadDocumentationDropoff(data: { id_vendor_dropoff: number, penerima: string, file: File }): Promise<{ message: string }> {
        const formData = FetchUtils.convertModelToFormData(data)
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/dropoff/upload`,
            {
                method: 'POST',
                body: formData
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async UpdateVendorDropoff(data: DropOffEntity, fields: { qty_regular?: number, qty_vegetarian?: number, }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/dropoff/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteVendorDropoff(data: DropOffEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/dropoff/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

export { VendorDropoffService };